import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SessionManager } from '../../../../../session/service/session-manager';

@Component({
  templateUrl: './tabs.component.html',
  styleUrls: [ './tabs.component.scss' ]
})
export class AdminCustomerTabsComponent implements OnInit {

  currentUrl: string;
  user: any = {};
  license = null;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private sessionManager: SessionManager) {
  }

  ngOnInit(): void {
    this.setCurrentUrl((<any>this.route.snapshot)._routerState.url);
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.setCurrentUrl(event.url);
      }
    });

    this.sessionManager.getIdentity()
      .subscribe((response) => {
        this.user = response;
      });
  }

  setCurrentUrl(url: string) {
    this.currentUrl = url;
  }
}
